import { LazyLoadImage } from 'react-lazy-load-image-component';
import logoBprBlack from '../../assets/img/logo/logobprblack.png';
import { FiPhone } from "react-icons/fi";
import { CiMail } from "react-icons/ci";
import logoOjk from '../../assets/img/logo/logoojk.png';
import logoLps from '../../assets/img/logo/logolps.png';
import { FaFacebook, FaInstagram, FaTiktok } from 'react-icons/fa';

export default function Footer() {

    const yearNow = new Date().getFullYear();
    return (
        <>
            <div className='bg-[#D9D9D9]'>
                <div className="max-w-screen-2xl mx-auto pt-8 md:pt-16 pb-16 md:pb-18 px-4 md:px-8 lg:px-16">
                    <footer>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                            {/* Column 1: Logo dan Alamat */}
                            <div className='space-y-3 flex flex-col justify-center items-center md:block'>
                                <LazyLoadImage
                                    src={logoBprBlack}
                                    alt="Logo BPR"
                                    effect='blur'
                                    className="w-48 md:w-[200px] h-auto"
                                />
                                <div className='text-center md:text-start'>
                                    <p className='font-poppinsRegular text-sm md:text-md mb-2'>Kantor pusat</p>
                                    <p className='font-poppinsRegular text-sm md:text-md'>
                                        Jl. Jenderal Basuki Rahmat No. 86, Birobuli Utara, Palu Selatan, Tatura Sel.,
                                        Kec. Palu Sel., Kota Palu, Sulawesi Tengah 94111
                                    </p>
                                </div>
                            </div>

                            {/* Column 2: Hubungi Kami */}
                            <div className='space-y-3 mt-10 flex flex-col justify-center items-center md:block'>
                                <h3 className='font-poppinsMedium text-lg'>Hubungi Kami</h3>
                                <div className='space-y-3 flex flex-col justify-center items-center md:block'>
                                    <span
                                        className='flex items-center hover:text-blue-600'>
                                        <FiPhone className="w-5 h-5" />
                                        <span className='ml-2 text-sm md:text-md'>0451-465000</span>
                                    </span>
                                    <a href="mailto:bprpaluanugerah@gmail.com"
                                        className='flex items-center hover:text-blue-600'>
                                        <CiMail className="w-5 h-5" />
                                        <span className='ml-2 text-sm md:text-md'>bprpaluanugerah@gmail.com</span>
                                    </a>
                                </div>
                            </div>

                            {/* Column 3: Media Sosial */}
                            <div className='space-y-4 mt-10 text-center md:text-start'>
                                <h3 className='font-poppinsMedium text-lg'>Media Sosial</h3>
                                <div className='space-y-3 flex flex-col justify-center items-center md:block'>
                                    <a href="https://www.facebook.com/Bprpaluanugerah01"
                                        className='flex items-center hover:text-blue-600'>
                                        <FaFacebook className="w-5 h-5" />
                                        <span className='ml-2 text-sm md:text-md'>Bprpaluanugerah01</span>
                                    </a>
                                    <a href="https://www.instagram.com/bprpaluanugerah/"
                                        className='flex items-center hover:text-blue-600'>
                                        <FaInstagram className="w-5 h-5" />
                                        <span className='ml-2 text-sm md:text-md'>@bprpaluanugerah</span>
                                    </a>
                                    <a href="https://www.tiktok.com/@bprpaluanugerah"
                                        className='flex items-center hover:text-blue-600'>
                                        <FaTiktok className="w-5 h-5" />
                                        <span className='ml-2 text-sm md:text-md'>bprpaluanugerah</span>
                                    </a>
                                </div>
                            </div>

                            {/* Column 4: Logo OJK & LPS */}
                            <div className="space-y-6 mt-10">
                                {/* OJK Section */}
                                <div className="flex flex-col gap-4 items-center md:flex-row md:items-start">
                                    <div className="flex-1 md:border-r-4 border-red-600 font-poppinsRegular font-bold md:pr-4">
                                        <h2 className="text-center md:text-left">Berizin dan diawasi oleh</h2>
                                    </div>
                                    <div className="flex-1 font-poppinsBold">
                                        <h2 className="text-center md:text-left text-red-600">OTORITAS JASA KEUANGAN</h2>
                                    </div>
                                </div>

                                {/* Lembaga Simpan Pinjam Section */}
                                <div className="flex flex-col gap-4 items-center md:flex-row md:items-start">
                                    <div className="flex-1 md:border-r-4 border-[#cc9900] font-poppinsRegular font-bold md:pr-4">
                                        <h2 className="text-center md:text-left">Merupakan peserta penjamin</h2>
                                    </div>
                                    <div className="flex-1 font-poppinsBold">
                                        <h2 className="text-center md:text-left text-[#cc9900]">LEMBAGA PENJAMIN SIMPANAN</h2>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </footer>
                </div>
            </div>
            <div className='bg-bprDarkBlue'>
                <div className='text-center font-poppinsBold text-sm md:text-md p-4 text-white'>
                    © {yearNow} BPR PALU ANUGERAH
                </div>
            </div>
        </>
    )
}